//Add wishlist
// Fix addEventListener 20250615 use shop-enhancer-core.js
//More concise and optimized 20250617
//Fix collection custom 20250629
//code 1
/*------ error when not calling back event add Dom code, slider render
document.addEventListener("DOMContentLoaded", function () {
  const wishlistIcons = document.querySelectorAll(".add-to-wishlist");

  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  wishlistIcons.forEach((icon) => {
  //  const productId = icon.dataset.productId; //shopify is not use
    const productHandle = icon.dataset.handle;
    //check 
  //  console.log('Handle Product Name:', productHandle);
    if (!productHandle) {
      console.log("No handle");
   // return;
  }

    // Set initial state
    if (wishlist.includes(productHandle)) {
      icon.classList.add("added");
    }
 updateWishlistCount();
 //     icon.addEventListener("click", function (e) {
 //     e.preventDefault();    // prevent link navigation
//      e.stopPropagation();   // prevent bubbling to parent elements

//      if (wishlist.includes(productHandle)) {
//        wishlist = wishlist.filter((h) => h !== productHandle);
//        icon.classList.remove("added");
//      } else {
//        wishlist.push(productHandle);
//        icon.classList.add("added");
//      }

//      localStorage.setItem("wishlist", JSON.stringify(wishlist));
//    });

  // SEPARATE the wishlist toggle logic into a shared function
    const toggleWishlist = () => {
      if (wishlist.includes(productHandle)) {
        wishlist = wishlist.filter((h) => h !== productHandle);
        icon.classList.remove("added");
      } else {
        wishlist.push(productHandle);
        icon.classList.add("added");
      }
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
    };

    //  ORIGINAL CLICK EVENT
    icon.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist();
    });

    // NEW ADDED: Keydown event to support Enter and Space keys
    icon.addEventListener("keydown", function (e) {
      if (e.key === "Enter" || e.key === " " || e.code === "Space") {
        e.preventDefault(); // Ngăn cuộn trang nếu Space
        toggleWishlist();
      }
    });

    
  });
});

// Set SEPARATE container listener after DOM is ready
const container = document.querySelector(".product-list") || document.body;
//  additional notice
function showToast(message = "Added to cart!") {
  const toast = document.getElementById("toast");
  if (!toast) return;

  toast.textContent = message;
  toast.classList.add("show");

  setTimeout(() => {
    toast.classList.remove("show");
  }, 2000);
}

//Add wishlist count
function updateWishlistCount() {
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const count = wishlist.length;
  const badge = document.querySelector(".wishlist-count-bubble span[aria-hidden='true']");
  const srText = document.querySelector(".wishlist-count-bubble .visually-hidden");

  if (badge) badge.textContent = count;
  if (srText) srText.textContent = `${count} item${count !== 1 ? 's' : ''} in wishlist`;

  // hide badge if It is item
  const container = document.querySelector(".wishlist-count-bubble");
  if (container) {
    if (count === 0) {
      container.style.display = "none";
    } else {
      container.style.display = "flex";
    }
  }
}

// Call page load
document.addEventListener("DOMContentLoaded", updateWishlistCount);

// additional notice 

container.addEventListener("click", async function (e) {
  // Remove Wishlist
  if (e.target.classList.contains("remove-wishlist")) {
    const id = e.target.dataset.handle;
    const handle = e.target.dataset.handle;
     console.log('handle remove Name:', handle);
    let list = JSON.parse(localStorage.getItem("wishlist")) || [];
    list = list.filter((h) => h !== handle);
    localStorage.setItem("wishlist", JSON.stringify(list));
    location.reload();
  }

  // Add to Cart
  if (e.target.classList.contains("add-to-cart")) {
    const variantId = e.target.dataset.id;
  //  await fetch('/cart/add.js', {
  //    method: 'POST',
  //    headers: { 'Content-Type': 'application/json' },
  //    body: JSON.stringify({ id: variantId, quantity: 1 })
  //  });
 try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      });

      showToast("Yay! It's in your cart!");
    } catch (err) {
      console.error("Add to cart error:", err);
      showToast("Error adding to cart!");
    }
    
    e.target.innerText = "Added!";
    e.target.disabled = true;
    setTimeout(() => {
      e.target.innerText = "Add to Cart";
      e.target.disabled = false;
    }, 2000);
  }
});
------*/
//code 2
// more concise and optimized 20250617
/*------ 
// ========== FILE: wishlist.js ==========
window.shopEnhancer = window.shopEnhancer || {};

// Toast announced
function showToast(message = "Added to cart!") {
  const toast = document.getElementById("toast");
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("show");
  setTimeout(() => toast.classList.remove("show"), 2000);
}

//  Count wishlist displayed on icon
window.shopEnhancer.updateWishlistCount = function () {
  const wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
  const count = wishlist.length;
  const badge = document.querySelector(".wishlist-count-bubble span[aria-hidden='true']");
  const srText = document.querySelector(".wishlist-count-bubble .visually-hidden");
  const container = document.querySelector(".wishlist-count-bubble");

  if (badge) badge.textContent = count;
  if (srText) srText.textContent = `${count} item${count !== 1 ? 's' : ''} in wishlist`;

  if (container) {
    container.style.display = count === 0 ? "none" : "flex";
  }
};

// Reassign icons after loading by ajax or first tim
window.shopEnhancer.initWishlistIcons = function (container = document) {
  const wishlistIcons = container.querySelectorAll(".add-to-wishlist");
  let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];

  wishlistIcons.forEach((icon) => {
    const handle = icon.dataset.handle;
    if (!handle || icon.dataset.bound === "true") return;
    icon.dataset.bound = "true";

    if (wishlist.includes(handle)) icon.classList.add("added");

    const toggleWishlist = () => {
      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter((h) => h !== handle);
        icon.classList.remove("added");
      } else {
        wishlist.push(handle);
        icon.classList.add("added");
      }
      localStorage.setItem("wishlist", JSON.stringify(wishlist));
      if (window.shopEnhancer?.updateWishlistCount) {
        window.shopEnhancer.updateWishlistCount();
      }
    };

    icon.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist();
    });

    icon.addEventListener("keydown", (e) => {
      if (e.key === "Enter" || e.key === " " || e.code === "Space") {
        e.preventDefault();
        toggleWishlist();
      }
    });
  });
};

// Handle remove wishlist + add to cart
document.addEventListener("DOMContentLoaded", function () {
  // Call wishlist initialization first time
  if (window.shopEnhancer?.initWishlistIcons) {
    window.shopEnhancer.initWishlistIcons(document);
  }

  // Call first count update
  if (window.shopEnhancer?.updateWishlistCount) {
    window.shopEnhancer.updateWishlistCount();
  }

  const container = document.querySelector(".product-list") || document.body;

  container.addEventListener("click", async function (e) {
    // remove wishlist
    if (e.target.classList.contains("remove-wishlist")) {
      const handle = e.target.dataset.handle;
      let list = JSON.parse(localStorage.getItem("wishlist")) || [];
      list = list.filter((h) => h !== handle);
      localStorage.setItem("wishlist", JSON.stringify(list));
      location.reload();
    }

    // Add to cart
    if (e.target.classList.contains("add-to-cart")) {
      const variantId = e.target.dataset.id;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        showToast("Yay! It's in your cart!");
        e.target.innerText = "Added!";
        e.target.disabled = true;
        setTimeout(() => {
          e.target.innerText = "Add to Cart";
          e.target.disabled = false;
        }, 2000);
      } catch (err) {
        console.error("Add to cart error:", err);
        showToast("Error adding to cart!");
      }
    }
  });
});
------ */
// ========== FILE: wishlist.js ==========
window.shopEnhancer = window.shopEnhancer || {};


// Toast of wishlist 
function showWishlistToast(message = "Added to wishlist!") {
  const container = document.getElementById("toast-container");
  if (!container) return;

  const toast = document.createElement("div");
  toast.className = "toast success"; // add class : success/info/error
  toast.textContent = message;
  container.appendChild(toast);
  // 👇 Add spacer before to always be the last toast
 // container.insertBefore(toast, spacer);
 // ✅ Scroll after DOM render
/* requestAnimationFrame(() => {
    setTimeout(() => {
      container.scrollTop = container.scrollHeight;
    }, 0);
  }); */
   // ✅ Đợi DOM render rồi scroll chính xác
  setTimeout(() => {
    toast.scrollIntoView({
      behavior: "smooth",
      block: "end",  // 👈 đảm bảo toast nằm cuối vùng nhìn thấy
    });
  }, 0);
   
  setTimeout(() => {
    toast.classList.add("hide");
    toast.addEventListener("transitionend", () => toast.remove());
  }, 2000);
}
// End toast code
/*
function showToast(message = "Wishlist") {
  const toast = document.getElementById("toast");
  if (!toast) return;
  toast.textContent = message;
  toast.classList.add("show");
  setTimeout(() => toast.classList.remove("show"), 2000);
}
*/
function showToast(message) {
  const container = document.getElementById("toast-container");
  if (!container) return;

  const toast = document.createElement("div");
  toast.className = "toast";
  toast.textContent = message;
  container.appendChild(toast);
  // 👇 Add spacer before to always be the last toast
  container.insertBefore(toast, spacer);
 // ✅ Scroll after DOM render
  requestAnimationFrame(() => {
    container.scrollTop = container.scrollHeight;
  });
  toast.addEventListener("animationend", (e) => {
    if (e.animationName === "fadeOut") toast.remove();
  });
}

// Wishlist memory
let wishlist = JSON.parse(localStorage.getItem("wishlist")) || [];
function saveWishlist() {
  localStorage.setItem("wishlist", JSON.stringify(wishlist));
}

// Update count icon
window.shopEnhancer.updateWishlistCount = function () {
  const count = wishlist.length;
  const badge = document.querySelector(".wishlist-count-bubble span[aria-hidden='true']");
  const srText = document.querySelector(".wishlist-count-bubble .visually-hidden");
  const container = document.querySelector(".wishlist-count-bubble");

  if (badge) badge.textContent = count;
  if (srText) srText.textContent = `${count} item${count !== 1 ? 's' : ''} in wishlist`;
  if (container) container.style.display = count === 0 ? "none" : "flex";
};

// Initialize wishlist buttons
window.shopEnhancer.initWishlistIcons = function (container = document) {
  container.querySelectorAll(".add-to-wishlist").forEach((icon) => {
    const handle = icon.dataset.handle;
    if (!handle || icon.dataset.bound === "true") return;

    icon.dataset.bound = "true";
    if (wishlist.includes(handle)) icon.classList.add("added");

    const toggleWishlist = () => {
       let action; //add action line
      if (wishlist.includes(handle)) {
        wishlist = wishlist.filter((h) => h !== handle);
        icon.classList.remove("added");
        action = "removed from";
      } else {
        wishlist.push(handle);
        icon.classList.add("added");
        action = "added to";
      }
      saveWishlist();
      window.shopEnhancer.updateWishlistCount();
      // NOTE: Show toast add/remove wishlist
      showWishlistToast(`Item ${action} wishlist`);
      // ================================
    };

    icon.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      toggleWishlist();
    });

    icon.addEventListener("keydown", (e) => {
      if (["Enter", " ", "Space"].includes(e.key || e.code)) {
        e.preventDefault();
        toggleWishlist();
      }
    });
  });
};

document.addEventListener("DOMContentLoaded", () => {
  window.shopEnhancer.initWishlistIcons(document);
  window.shopEnhancer.updateWishlistCount();

  const container = document.querySelector(".product-list") || document.body;

  container.addEventListener("click", async (e) => {
    // Remove from wishlist
    if (e.target.classList.contains("remove-wishlist")) {
      const handle = e.target.dataset.handle;
     wishlist = wishlist.filter((h) => h !== handle);
     saveWishlist();
     window.shopEnhancer.updateWishlistCount();
      e.target.closest(".product-card")?.remove(); // Optional
      e.target.innerText = "Deleted Wishlist";
      showToast("Item removed from wishlist");
      return;
    }

    // Add to cart
   if (e.target.classList.contains("add-to-cart")) {
 // if (e.target.classList.contains("add-to-cart_new")) {
      const variantId = e.target.dataset.id;
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        showToast("Yay! It's in your cart!");
        e.target.innerText = "Added to cart!";
        e.target.disabled = true;
        setTimeout(() => {
          e.target.innerText = "Added to Cart";
          e.target.disabled = false;
        }, 2000);
      } catch (err) {
        console.error("Add to cart error:", err);
       // showToast("Error adding to cart!");
      }
    }
  });
});

//
window.shopEnhancer = window.shopEnhancer || {};

window.shopEnhancer.toggleWishlist = function (handle) {
  const wishlist = JSON.parse(localStorage.getItem('wishlist')) || [];
  const index = wishlist.indexOf(handle);
  if (index > -1) {
    wishlist.splice(index, 1);
  } else {
    wishlist.unshift(handle);
  }

  localStorage.setItem('wishlist', JSON.stringify(wishlist));
  window.shopEnhancer.updateWishlistCount();
};

// ✅ Dispatch after the entire function has been defined
window.dispatchEvent(new Event('shopEnhancer:ready'));//Fix collection custom 20250629

